import {
  listRegionTags as ListRegionTagsRequest,
  createRegionTag as createRegionTagRequest,
  deleteRegionTag as deleteRegionTagRequest,
  getRegionTag as getRegionTagRequest,
  updateRegionTag as updateRegionTagRequest
} from '@cbgms/api/modules/bank-holidays/requests'
import { ICreateRegionTag, IListRegionTag, IListRegionTagsResponse, IRegionTag, IRegionTagResponse, IResponse } from '@cbgms/api'
import * as types from 'gms-support/src/app-support/regions/state/types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { query } from '@cbgms/components/list'

export const listRegionTags = () =>
  AsyncAction<IListRegionTagsResponse>({
    type: [types.GET_REGION_TAGS, types.GET_REGION_TAGS_SUCCESS, types.GET_REGION_TAGS_FAILED],
    payload: {
      api: 'support',
      request: ListRegionTagsRequest({
        fields: '*'
      })
    }
  })

export const regionsForCountry = (countryCode: string) =>
  AsyncAction<IListRegionTagsResponse>({
    type: [types.GET_REGION_TAGS, types.GET_REGION_TAGS_SUCCESS, types.GET_REGION_TAGS_FAILED],
    payload: {
      api: 'support',
      request: ListRegionTagsRequest({
        fields: '*',
        search: query<IListRegionTag>()
          .equals(a => a.Region.Country, countryCode)
          .toString()
      })
    }
  })

export const getRegionTag = (regionTagUUID: string) =>
  AsyncAction<IRegionTagResponse>({
    type: [types.GET_REGION_TAG, types.GET_REGION_TAG_SUCCESS, types.GET_REGION_TAG_FAILED],
    payload: {
      api: 'support',
      request: getRegionTagRequest(regionTagUUID)
    }
  })

export const updateRegionTag = (regionTagUUID: string, data: Partial<IRegionTag>) =>
  AsyncAction<IResponse<{ UUID: string }>>({
    type: [types.UPDATE_REGION_TAG, types.UPDATE_REGION_TAG_SUCCESS, types.UPDATE_REGION_TAG_FAILED],
    payload: {
      api: 'support',
      request: updateRegionTagRequest(regionTagUUID, data)
    }
  })

export const deleteRegionTag = (regionTagUUID: string) =>
  AsyncAction<IResponse<{ UUID: string }>>({
    type: [types.DELETE_REGION_TAG, types.DELETE_REGION_TAG_SUCCESS, types.DELETE_REGION_TAG_FAILED],
    payload: {
      api: 'support',
      request: deleteRegionTagRequest(regionTagUUID)
    }
  })

export const createRegionTag = (data: ICreateRegionTag) =>
  AsyncAction<IResponse<{ UUID: string }>>({
    type: [types.CREATE_REGION_TAG, types.CREATE_REGION_TAG_SUCCESS, types.CREATE_REGION_TAG_FAILED],
    payload: {
      api: 'support',
      request: createRegionTagRequest(data)
    }
  })
